import React from 'react'
import { Box, Link } from '@ally/metronome-ui'

import Widget from '../../Widget'
import WidgetBody from './WidgetBody'
import WidgetTitle from '../WidgetTitle'
import { useHostServices } from '../../../HostServices'

const WidgetFooter: React.FC = (): React.ReactElement => {
  return (
    <Box textAlign="right">
      <Link text="View Gallery" to="/gallery" withAllyTM="badges-viewGallery" />
    </Box>
  )
}

const BadgeWidget: React.FC = () => {
  const { featureFlags } = useHostServices()
  const isGalleryPageEnabled = featureFlags.variation(
    'FF_badge-gallery-page',
    false,
  )
  return (
    <Widget
      widgetTitle={<WidgetTitle title="Badges" />}
      widgetAriaLabel="Achievement Badges"
      widgetBody={<WidgetBody />}
      footer={isGalleryPageEnabled ? <WidgetFooter /> : null}
      dataTestId="badges-widget"
    />
  )
}

export default BadgeWidget
